<template>
	<v-layout row wrap>
		<v-flex md8 class="body-border-right body-border-right-full pl-0">
			<div class="form-section">
				<p class="text-xs-left medium">Nuevo tipo de limpieza</p>
			</div>
			<v-container fluid class="grid-list-xl">
				<v-layout row wrap class="form-section text-xs-left">
					<v-flex md4>
						<div class="label-section mb-2">
							<label for="name">Nombre del tipo de limpieza</label>
						</div>
						<div class="control">
							<input
								id="name"
								name="name"
								type="text"
								v-model="model.name"
								class="input-form"
								placeholder="Ejem. Ocupado sucio"
							/>
						</div>
					</v-flex>
					<v-flex md4>
						<div class="label-section mb-2">
							<label for="code">Siglas del tipo de limpieza</label>
						</div>
						<div class="control">
							<input
								id="code"
								name="code_setting"
								type="text"
								v-model="model.code_setting"
								class="input-form"
								placeholder="Ejem. OS"
							/>
						</div>
					</v-flex>
					<v-flex md4>
						<div class="label-section mb-2">
							<label for="color">Color picker</label>
						</div>
						<div class="control">
							<div class="color-picker">
								<v-menu v-model="showColorPicker" offset-x v-bind:close-on-content-click="false"
									v-bind:top="true" v-bind:full-width="true">
									<div slot="activator">
										<input id="color" name="color_setting" type="text" class="input-form" v-model="model.color_setting"
										/>
										<div class="current-color" v-bind:style="currentPicker"></div>
									</div>
									<v-list class="menu-color-picker">
										<button type="button" class="btn-danger" v-on:click="showColorPicker = false">Cerrar</button>
										<chrome-picker v-bind:value="colors" v-on:input="onUpdateColor" />
									</v-list>
								</v-menu>
							</div>
						</div>
					</v-flex>
				</v-layout>
			</v-container>
			<v-container fluid class="grid-list-md text-xs-left mt-3">
				<div class="label-section mb-2">
					<label>Seleccione el ícono</label>
				</div>
				<v-layout row wrap class="form-section text-xs-left">
					<v-flex md1 v-for="state in states" :key="state.id">
						<input
							type="radio"
							hidden
							name="icons"
							:value="state"
							v-model="model.stateSelected"
							v-on:change="updateIcon()"
							:id="state.id">
						<label :for="state.id" class="select-icon-states">
							<img :src="state.imageUrl" alt="">
						</label>
					</v-flex>
				</v-layout>
			</v-container>
			<v-layout row wrap>
				<v-flex xs3>
					<div class="form-section text-xs-left">
						<div class="label-section mt-4 mb-2">
							<label>Subir ícono</label>
						</div>
						<file-upload-container
							class="mb-3"
							v-bind:label-for="`image-${model.image.id}`"
							v-on:upload="onUploadImage"
							v-bind:image-url="model.image.imageUrl"
							v-bind:min-resolution="20"
							v-bind:max-resolution="20"
						/>
					</div>
				</v-flex>
			</v-layout>
			<v-layout row wrap>
				<v-btn
					class="btn-save mr-3"
					v-on:click="createSetting"
					:loading="loading"
					:disabled="loading">
					Guardar
				</v-btn>
				<v-btn class="btn-cancel" :to="settingsHref">
					Cancelar
				</v-btn>
			</v-layout>
		</v-flex>
		<v-flex md4>
			<div class="form-section">
				<p class="text-xs-center medium">Vista previa</p>
			</div>
			<v-layout row wrap justify-center>
				<v-flex xs6>
					<v-layout row wrap justify-center class="new-state-container">
						<v-flex xs12>
							<room-status
								v-bind:class="{ 'topProperty' : !model.name }"
								v-bind:background-color="model.color_setting"
								v-bind:status-icon-img="model.image.imageUrl !== preimage ? model.image.imageUrl : model.stateSelected.imageUrl"
								v-bind:name="model.code_setting"
								v-bind:room="model">
							</room-status>
						</v-flex>
						<v-flex xs12>
							<p>{{ model.name }}</p>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout row wrap mt-5>
				<v-flex md12>
					<table class="table">
						<thead>
							<tr>
								<th>Tipo de habitación</th>
								<th>Tiempo estándar</th>
								<th v-if="settingId">&nbsp;</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="roomtype in model.standardTime"
								:key="roomtype.id"
								v-if="roomtype.id">
								<td>{{ roomtype.name }}</td>
								<td>
									<v-text-field
										type="number"
										class="time-standard-input"
										suffix="min"
										min="1"
										step="1"
										v-model.number="roomtype.time"
										v-on:keyup="toInt(roomtype.time)"
										hide-details>
									</v-text-field>
								</td>
								<td
									class="td-icon"
									v-if="settingId">
									<v-icon v-on:click.stop="openCheckList(roomtype)">playlist_add</v-icon>
								</td>
							</tr>
						</tbody>
					</table>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-dialog v-model="dialog" width="685" content-class="modal-dashboard">
			<v-card>
				<v-card-title class="headline">
					Agregar tareas
					<v-icon v-on:click.stop="closeModal">cancel</v-icon>
				</v-card-title>
				<v-card-text>
					<v-layout row wrap text-xs-left>
						<v-flex md10 pr-2>
							<input
								type="text"
								class="input-border-inset"
								v-model="newTask"
								v-on:keyup.enter="addTask"/>
						</v-flex>
						<v-flex md2 pl-3>
							<v-btn
								class="btn-add"
								v-on:click="addTask"
								:loading="loading"
								:disabled="loading">
								<v-icon>add</v-icon>
								Agregar
							</v-btn>		
						</v-flex>
					</v-layout>
					<v-layout row wrap text-xs-left mt-3>
						<table-run
							v-bind:columns="columns"
							v-bind:rows="rows"
							key-value="text"
							v-bind:selectable="false"
							v-bind:include-delete="false"
							v-bind:include-export-to-excel="false"
							v-bind:include-switch="false"
							v-bind:include-settings="false"
							v-bind:include-search="false"
							v-bind:include-options="true"
							v-bind:include-delete-single="true"
							v-on:on-delete-event="deleteRow"
							class="no-selectable-table">
							<template slot="rows" scope="props">
								<td>{{ props.row.text }}</td>
							</template>
						</table-run>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						class="btn-save mr-3 mb-2"
						v-on:click.stop="saveCheckList"
						:loading="loading"
						:disabled="loading">
						Guardar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { Chrome } from 'vue-color';
import TableRun from 'table-run';
import helper from '@/shared/helper';
import mixin from '@/shared/mixins';
import settingResource from '@/resource/setting';
import RoomStatus from '@/components/shared/RoomStatus';
import TasksList from '@/components/shared/TasksList';
import FileUploadContainer from '@/components/shared/FileUpload/FileUploadContainer';

const DEFAULT_COLOR = '#14E1BF';
const helperData = helper.data();

const defaultProps = {
	hex: DEFAULT_COLOR,
	hsl: {
		h: 150,
		s: 0.5,
		l: 0.2,
		a: 1,
	},
	hsv: {
		h: 150,
		s: 0.66,
		v: 0.30,
		a: 1,
	},
	rgba: {
		r: 25,
		g: 77,
		b: 51,
		a: 1,
	},
	a: 1,
};

function created() {
	this.resource = settingResource(this);
	if (this.settingId) {
		this.loadData();
	} else {
		this.loadRoomtypes();
	}
}

async function addTask() {
	if (this.modelCheckList.id) {
		await this.$http.patch(`${process.env.CHECKLIST_URL}/check-list/${this.modelCheckList.id}`, { text: this.newTask });
		this.rows.push({ text: this.newTask });
		this.newTask = '';
		this.showNotification('La tarea se agregó correctamente.', 'success');
	} else {
		this.rows.push({ text: this.newTask });
		this.newTask = '';
	}
}

async function createSetting() {
	try {
		this.loading = true;
		if (this.model.image.imageUrl !== helperData.preimageUrl) {
			this.model.url_image = this.model.image.imageUrl;
		} else if (this.model.stateSelected.imageUrl !== helperData.preimageUrl) {
			this.model.url_image = this.model.stateSelected.imageUrl;
		} else {
			this.model.url_image = null;
		}
		if (this.settingId) {
			await this.resource.update({ id: this.settingId }, this.model);
			this.showNotification('El estado se actualizó, correctamente', 'success');
		} else {
			await this.resource.save(this.model);
			this.showNotification('El estado se creó, correctamente', 'success');
		}
		this.$router.push(this.settingsHref);
	} catch (err) {
		if (this.settingId) {
			this.showNotification('No se pudo actualizar el estado', 'error');
		}
	}
	this.loading = false;
}

function closeModal() {
	this.dialog = false;
	this.modelCheckList.name = null;
	this.modelCheckList.roomTypeId = null;
	this.modelCheckList.typeCleaningId = null;
	this.modelCheckList.items = [];
	this.rows = [];
	this.newTask = null;
	if (this.modelCheckList.id) {
		this.modelCheckList.id = null;
	}
}

async function deleteRow(row) {
	if (row.id) {
		await this.$http.delete(`${process.env.CHECKLIST_URL}/check-list/${row.id}`);
		const rowIndex = this.rows.findIndex(item => item.text === row.text);
		this.rows.splice(rowIndex, 1);
		this.showNotification('La tarea se eliminó correctamente', 'success');
	} else {
		const rowIndex = this.rows.findIndex(item => item.text === row.text);
		this.rows.splice(rowIndex, 1);
	}
}

async function loadData() {
	const response = await this.resource.get({ id: this.settingId });
	const stateExist = this.states.filter(state => response.data.url_image === state.imageUrl);
	if (stateExist.length > 0) {
		response.data.stateSelected = {
			id: stateExist[0].id,
			imageUrl: response.data.url_image,
		};
		response.data.image = {
			id: 1,
			imageUrl: helperData.preimageUrl,
		};
	} else {
		response.data.image = {
			id: response.data.id,
			imageUrl: response.data.url_image,
		};
		response.data.stateSelected = {
			id: 1,
			imageUrl: null,
		};
	}
	this.model = response.data;
}

async function loadRoomtypes() {
	const response = await this.$http.get('roomtype-simple-list');
	this.model.standardTime = response.data.map((roomtype) => {
		const newRoomtype = Object.assign({}, roomtype);
		newRoomtype.time_standard = {
			id: roomtype.id,
			name: roomtype.name,
			time: 1,
		};
		return newRoomtype.time_standard;
	});
}

function onUpdateColor({ hex }) {
	this.model.color_setting = hex;
}

function onUploadImage(url, label) {
	if (this.settingId) {
		this.model.url_image = url;
		this.model.image.imageUrl = url;
		this.model.icon_url = null;
	} else {
		const image = this.model.image;
		image.id = Number(label.split('-')[1]);
		image.imageUrl = url;
	}
}

async function openCheckList(roomtype) {
	this.dialog = true;
	this.roomtypeSelected = roomtype;
	this.newTask = null;
	const response = await this.$http.get(`${process.env.CHECKLIST_URL}/check-list/${roomtype.id}/${this.settingId}`);
	if (response.data.items && response.data.items.length > 0) {
		this.modelCheckList = response.data;
		this.rows = response.data.items;
	} else {
		this.modelCheckList.id = null;
		this.modelCheckList.name = null;
		this.modelCheckList.roomTypeId = null;
		this.modelCheckList.typeCleaningId = null;
		this.modelCheckList.items = [];
		this.rows = [];
	}
}

async function saveCheckList() {
	if (!this.modelCheckList.id) {
		this.modelCheckList.name = `Checklist ${this.roomtypeSelected.name} - ${this.model.name}`;
		this.modelCheckList.roomTypeId = this.roomtypeSelected.id;
		this.modelCheckList.typeCleaningId = this.settingId;
		this.rows.forEach(row => this.modelCheckList.items.push({ text: row.text }));
		const modelSend = {
			name: this.modelCheckList.name,
			roomTypeId: this.modelCheckList.roomTypeId,
			typeCleaningId: this.modelCheckList.typeCleaningId,
			items: this.modelCheckList.items,
		};
		this.loading = true;
		await this.$http.post(`${process.env.CHECKLIST_URL}/check-list`, modelSend);
		this.showNotification('El listado de tareas se creó correctamente.', 'success');
		this.dialog = false;
		this.modelCheckList.id = null;
		this.modelCheckList.name = null;
		this.modelCheckList.roomTypeId = null;
		this.modelCheckList.typeCleaningId = null;
		this.modelCheckList.items = [];
		this.newTask = null;
		this.rows = [];
		this.loading = false;
	} else {
		this.modelCheckList.id = null;
		this.modelCheckList.name = null;
		this.modelCheckList.roomTypeId = null;
		this.modelCheckList.typeCleaningId = null;
		this.modelCheckList.items = [];
		this.newTask = null;
		this.dialog = false;
		this.rows = [];
		this.showNotification('Los cambios se guardaron correctamente.', 'success');
	}
}

function toInt(value) {
	const newValue = value.toString();
	if (!value) {
		this.showNotification('El valor para tiempo estándar debe ser un número válido', 'error');
		this.isDisabled = true;
	} else if (value <= 0) {
		this.showNotification('El mínimo valor requerido es 1', 'error');
		this.isDisabled = true;
	} else if (newValue && newValue !== '' && newValue.indexOf('.') > -1) {
		this.showNotification('El valor para tiempo estándar debe ser un número entero', 'error');
		this.isDisabled = true;
	} else {
		this.isDisabled = false;
	}
}

function updateIcon() {
	this.model.url_image = null;
	this.model.image.imageUrl = helperData.preimageUrl;
}

function currentPicker() {
	return `background-color: ${this.model.color_setting}`;
}

export default {
	components: {
		'chrome-picker': Chrome,
		FileUploadContainer,
		RoomStatus,
		TableRun,
		TasksList,
	},
	computed: {
		currentPicker,
	},
	created,
	data() {
		return {
			colors: defaultProps,
			columns: [
				{ id: 1, name: 'Tareas', code: 'text' },
			],
			dialog: false,
			loading: false,
			model: {
				code_setting: 'F',
				color_setting: DEFAULT_COLOR,
				image: {
					id: 1,
					imageUrl: helperData.preimageUrl,
				},
				name: 'Fumigación',
				stateSelected: {
					id: 4,
					imageUrl: helperData.outofserviceImageUrl,
				},
				standardTime: null,
			},
			modelCheckList: {
				name: null,
				roomTypeId: null,
				typeCleaningId: null,
				items: [],
			},
			newTask: null,
			preimage: helperData.preimageUrl,
			resource: null,
			roomtypeSelected: null,
			rows: [],
			settingsHref: { name: 'settings' },
			states: [
				{ id: 1, imageUrl: helperData.turnoverImageUrl },
				{ id: 2, imageUrl: helperData.maintenanceImageUrl },
				{ id: 3, imageUrl: helperData.cleandeepImageUrl },
				{ id: 4, imageUrl: helperData.outofserviceImageUrl },
				{ id: 5, imageUrl: helperData.lockedImageUrl },
				{ id: 6, imageUrl: helperData.dirtyImageUrl },
				{ id: 7, imageUrl: helperData.indeterminateImageUrl },
			],
			showColorPicker: false,
		};
	},
	methods: {
		addTask,
		closeModal,
		createSetting,
		deleteRow,
		loadData,
		loadRoomtypes,
		onUpdateColor,
		onUploadImage,
		openCheckList,
		saveCheckList,
		toInt,
		updateIcon,
	},
	mixins: mixin,
	name: 'settings-create',
	props: [
		'settingId',
	],
};
</script>

<style lang="scss" scoped>
	.form-section {
		.medium {
			color: map-get($colors, default-dark);
			font-family: map-get($fonts, medium);
			font-size: map-get($sizes, fourteen);
		}
	}

	.select-icon-states {
		align-items: center;
		background-color: white;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .18);
		cursor: pointer;
		display: inline-flex;
		height: 40px;
		justify-content: center;
		width: 42px;
	}

	.new-state-container {
		align-content: center;
		background-color: white;
		box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, .1);
		height: 104px;
		width: 183px;

		.chip-status.large {
			margin-bottom: 0px;
			margin-right: 0px;
		}

		p {
			align-self: flex-start;
			color: map-get($colors, default-label);
			margin-bottom: 0px;
		}
	}

	input[type="radio"]:checked + .select-icon-states {
		border: 1px solid map-get($colors, default-skyblue);
	}

	.color-picker {
		position: relative;
	}

	.current-color {
		bottom: 0;
		height: 24px;
		margin: auto;
		position: absolute;
		right: 8px;
		top: 0;
		width: 24px;
	}

	.table {
		thead th {
			color: map-get($colors, default-dark);
			font-family: map-get($fonts, medium);
			font-size: map-get($sizes, fourteen);
		}

		.td-icon {
			padding: 0px 10px 0px 0px;

			i {
				cursor: pointer;
			}
		}
	}

	.headline {
		color: map-get($colors, default-dark);
		font-family: map-get($fonts, medium);
		font-size: map-get($sizes, twenty) !important;
		padding-bottom: 0px;

		i {
			color: map-get($colors, header-dark);
			cursor: pointer;
			position: absolute;
			right: 10px;
			top: 10px;
		}
	}

	.input-border-inset {
		background-color: white;
		box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.16);
		height: 40px;
		outline: none;
		padding: 0 30px 0 14px;
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// Create.vue?7b485936